import { useSearchParams } from "react-router-dom";
import EmailTemplatesService from "../../../services/EmailTemplatesService";
import { ContactUs, EmailTemplate } from "../../../models";
import { useEffect, useState } from "react";
import ContactUsService from "../../../services/ContactUsService";
import ContactUsTable from "./ui/ContactUsTable";
import ContactUsTableSkeleton from "./skeletons/ContactUsTableSkeleton";
 
export default function ContactUsPage() {
    const [searchParams] = useSearchParams();
       const api = new ContactUsService();
       const [messages,setMessages] = useState<ContactUs[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchMessages();
       }, [searchParams.get("reload")]);
       
       const fetchMessages = async () => {
         const data = await api.getContactUs();        
         setMessages(data);     
         setLoading(false);     
       };
         
     return (
       <div className="w-full">
         <div className="flex w-full items-center justify-between">
           <h1 className={` text-2xl`}>Contact Us</h1>
         </div>         
         {loading ? <ContactUsTableSkeleton /> : <ContactUsTable messages={messages}/>}
       </div>
     );
   
}